const TRIP_COOKIE = 'ha-trip-prst';
const STATE_COOKIE = 'ha-state-prst';

function writeCookie(name, value, shouldEncode = true) {
    const expireTime = new Date();
    expireTime.setTime(expireTime.getTime() + 30 * 24 * 60 * 60 * 1000);
    // only stringify objects and arrays
    let cookieValue = typeof value === 'object' ? JSON.stringify(value) : value;
    cookieValue = shouldEncode ? encodeURIComponent(cookieValue) : cookieValue;
    const cookie = [
        name,
        '=',
        cookieValue,
        ';expires=',
        expireTime.toUTCString(),
        '; path=/;'
    ].join('');
    if (typeof document !== 'undefined') {
        document.cookie = cookie;
    }
}

/**
* readCookie
* @param {String} name - name of cookie to retrieve
* @param {Object} cookieSource - optional; source from which to retrieve cookie; defaults to document.cookie
* @returns {Object} - Eg. {
    lastSearchHash: "",
    lastSearchParam: "",
    lastSearchRegionNode: "1",
    lastSearchUrl: "/search",
    lbsKeywords: "" }
*/

/* eslint-disable no-console */
function readCookie(name, cookieSource, isJSON = true) {
    if (!cookieSource) {
        cookieSource = typeof document !== 'undefined' ? document.cookie : '';
    }
    const regexValue = '=([^;]+)';
    const match = cookieSource.match(new RegExp(name + regexValue));
    let result = isJSON ? {} : '';

    if (match && match.length > 0) {
        if (isJSON) {
            try {
                result = JSON.parse(decodeURIComponent(match[1]));
            } catch (e) {
                console.error(
                    'expected valid JSON; if you expected a string, pass isJSON=false as a parameter'
                );
            }
        } else {
            result = decodeURIComponent(match[1]);
        }
    }

    return result;
}

// Takes cookie formatted like 'functional:1;foo:0'
// and converts to object like {functional: 1, foo: 0}
function decodeCookie(cookie) {
    if (typeof cookie !== 'string') {
        return cookie;
    }

    let cookieObj = {};
    const cookieArray = cookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
        const cookieKey = cookieArray[i].split(':')[0];
        const cookieVal = cookieArray[i].split(':')[1];
        const cookieValNumified = !isNaN(cookieVal) ? parseInt(cookieVal, 10) : cookieVal;
        cookieObj[cookieKey] = cookieValNumified;
    }

    return cookieObj;
}

function userAllowsFunctionalCookies() {
    const cookieSettings = readCookie('ha-cookie-settings', global.window.document.cookie, false);
    const cookieSettingsObj = decodeCookie(cookieSettings);
    return !!cookieSettingsObj && !!cookieSettingsObj.functional;
}

module.exports = {
    writeCookie,
    readCookie,
    decodeCookie,
    userAllowsFunctionalCookies,
    STATE_COOKIE,
    TRIP_COOKIE
};
